import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../context/auth-context';
import HeaderShell from './HeaderShell';

const AdminHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const isAdminLoginPage = location.pathname === '/lkart/admin';
  const showLogoutButton = !isAdminLoginPage;

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      logout(); // clears admin_auth_token via AuthProvider's own logout()
      localStorage.removeItem('isTablet');
      toast.success('Logged out successfully');
      navigate('/lkart/admin');
    }
  };

  return (
    <HeaderShell
      showHomeButton={true}
      onHomeClick={() => navigate('/lkart/admin/view')}
      showBellButton={false}
      showLogoutButton={showLogoutButton}
      onLogoutClick={handleLogout}
    />
  );
};

export default AdminHeader;